import { FormattedDate, FormattedMessage } from 'react-intl';

interface TimeFormatterProps {
  date: string;
  is12hFormat: boolean | undefined;
  sessionDuration: number;
}

function TimeFormatter({ date, is12hFormat, sessionDuration }: TimeFormatterProps) {
  const getEndTime = (startDate: string, durationMinutes: number = 60) => {
    if (!startDate) return '';
    const start = new Date(startDate);
    const end = new Date(start.getTime() + durationMinutes * 60000);
    return end;
  };

  return (
    <div>
      <FormattedDate
        hour={is12hFormat ? 'numeric' : '2-digit'}
        minute={is12hFormat ? 'numeric' : '2-digit'}
        value={new Date(date)}
      />
      {' - '}
      <FormattedDate
        hour={is12hFormat ? 'numeric' : '2-digit'}
        minute={is12hFormat ? 'numeric' : '2-digit'}
        value={getEndTime(date, sessionDuration)}
      />
      {` (`}
      {`${sessionDuration}`} <FormattedMessage id="common.minutes" />
      {`) `}
    </div>
  );
}

export default TimeFormatter;
